export const MODAL_HEADER_HEIGHT = 60;
